import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-usuario-login',
  templateUrl: './usuario-login.component.html',
  styleUrls: ['./usuario-login.component.css']
})
export class UsuarioLoginComponent implements OnInit {
  

  constructor() {
    
  }

  ngOnInit() {
    
  }

  loginForm( form: NgForm ) {

    if (  form.invalid ) { return; }

    console.log('Login: ');

  }
}
